import styles from "./Navbar.module.css";
import { CircleCheckBig, X, Menu } from "lucide-react";
import { ToggleButton } from "../../PresentationalComponents/ToggleButton";
import { useState } from "react";

export function Navbar({ t, changeLanguage }) {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };
  return (
    <>
      <section className={styles.sectionContainer}>
        <div className={styles.logoDiv}>
          <span>
            F<span>Y</span>
          </span>
        </div>
        <ul>
          <li>
            <a href="#Projects">{t("work")}</a>
          </li>
          <li>
            <a href="#AboutMe">{t("about")}</a>
          </li>
          <li>
            <a href="#Skills">{t("skills")}</a>
          </li>
          <li>
            <a href="#Poblications">{t("articles")}</a>
          </li>
        </ul>
        <div className={styles.langBox}>
          <label>Fa</label>
          <ToggleButton width={40} changeLanguage={changeLanguage} />
          <label>En</label>
        </div>
        <div className={`${styles.statusContainer} ${styles.blink}`}>
          <span>{t("status")}</span>
          <CircleCheckBig className={styles.svg} />
        </div>
      </section>
      <section className={styles.mobileSectionContainer}>
        <div className={styles.mobileLogoDiv}>
          <span>
            F<span>Y</span>
          </span>
        </div>
        <div className={styles.langBox}>
          <label>Fa</label>
          <ToggleButton width={40} changeLanguage={changeLanguage} />
          <label>En</label>
        </div>
        <div className={`${styles.statusContainer} ${styles.blink}`}>
          <span>{t("status")}</span>
        </div>
        <Menu
          style={isOpen ? { display: "none" } : {}}
          className={styles.menuIcon}
          onClick={() => {
            setIsOpen(true);
            document.body.style.overflow = "hidden";
          }}
        />
        <X
          className={styles.menuIcon}
          style={isOpen ? {} : { display: "none" }}
          onClick={() => {
            setIsOpen(false);
            document.body.style.overflow = "auto";
          }}
        />
      </section>

      <div className={`${styles.mobileMenu}${isOpen ? " " + styles.open : ""}`}>
        <div className={styles.menuHeader}>
          <div className={styles.logoNavContainer}></div>
          <h2>{t("name")}</h2>
          <p>{t("hero.title")}</p>
        </div>
        <div className={styles.menuNav}>
          <ol>
            <div></div>
            <li>
              <a href="#Projects" onClick={closeMenu}>
                {t("work")}
              </a>
            </li>
            <div></div>
            <li>
              <a href="#AboutMe" onClick={closeMenu}>
                {t("about")}
              </a>
            </li>
            <div></div>
            <li>
              <a href="#Skills" onClick={closeMenu}>
                {t("skills")}
              </a>
            </li>
            <div></div>
            <li>
              <a href="#Poblications" onClick={closeMenu}>
                {t("articles")}
              </a>
            </li>
            <div></div>
          </ol>
        </div>
        <div className={styles.menuStatus}>
          <div className={styles.statusContainer}>
            <span>{t("status")}</span>
          </div>
          <p>{t("status-description")}</p>
        </div>
      </div>
    </>
  );
}
